import { render } from "./home_info.vue?vue&type=template&id=3a8f934a&scoped=true"
const script = {}

import "./home_info.vue?vue&type=style&index=0&id=3a8f934a&scoped=true&lang=css"

import exportComponent from "C:\\Прогерство\\vue\\new_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8f934a"]])

export default __exports__